<script setup>
/* global defineProps */
import { computed, onMounted, onUnmounted, ref } from "vue";
import { formatElapsed, formatTracked } from "@/views/internal-tickets/runningTimeEntries";

const props = defineProps({
  // Entrada de Trackernet en marcha (timeStart y empleado), si hay alguna
  entry: {
    type: Object,
    default: null
  },
  // Segundos ya imputados en Trackernet al ticket (todas las entradas, de todos los usuarios)
  total: {
    type: Number,
    default: 0
  }
});

const now = ref(Date.now());
let intervalId = null;

const elapsed = computed(() => (props.entry ? formatElapsed(props.entry.timeStart, now.value) : ''));
const title = computed(() => 'En marcha: ' + (props.entry?.employee?.fullName || ''));
const tracked = computed(() => formatTracked(props.total));

onMounted(() => {
  intervalId = setInterval(() => { now.value = Date.now(); }, 30000);
});

onUnmounted(() => clearInterval(intervalId));
</script>

<template>
  <span class="tracked-time">
    <span v-if="tracked" class="tracked-time__total" title="Tiempo imputado en Trackernet">{{ tracked }}</span>
    <el-tooltip v-if="entry" placement="top" effect="light" :content="title">
      <span class="running-clock">
        <svg class="running-clock__icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
        {{ elapsed }}
      </span>
    </el-tooltip>
  </span>
</template>

<style scoped>
.tracked-time {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
}

.tracked-time__total {
  font-weight: 700;
  white-space: nowrap;
}

.running-clock {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
  white-space: nowrap;
  color: #1f9d55;
}

.running-clock__icon {
  flex: none;
  animation: running-pulse 1.6s ease-in-out infinite;
}

@keyframes running-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
</style>
